import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'FETCH_VARIANTS',
  'FETCH_COPY_NUMBERS',
  'FETCH_STRUCTURAL_VARIANTS',
  'FETCH_GENOMIC_TEST_SUMMARY',
  'FETCH_EXPRESSIONS',
]);

export default {
  ...asyncActions,
};
